var render = function () {
  var _vm$report$customerAd;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "fill-height",
    attrs: {
      "no-gutters": ""
    }
  }, [_vm.isLoading ? _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-skeleton-loader', {
    attrs: {
      "type": "card-heading, divider, list-item-two-line, list-item-two-line, list-item-two-line"
    }
  })], 1) : _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "12"
    }
  }, [_c('v-tabs', {
    staticClass: "fill-height",
    attrs: {
      "vertical": !_vm.isMobile,
      "background-color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    },
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _c('v-tab', {
    staticStyle: {
      "width": "200px"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-office-building-outline")]), _vm._v(" " + _vm._s(_vm.$t("components.partner.PartnerReportDetail.PartnerReportUpdateReportDialog.report.parties.title")) + " ")], 1), _c('v-tab', [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v("mdi-account-multiple-outline")]), _vm._v(" " + _vm._s(_vm.$t("nav.PERSON_TABLE.title")) + " ")], 1), _c('v-tab-item', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), !_vm.isMobile || _vm.isMobile && !_vm.activeCompany ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-list', {
    staticClass: "py-0 ",
    attrs: {
      "tile": ""
    }
  }, [_c('v-list-item-group', {
    model: {
      value: _vm.activeCompanyIndex,
      callback: function callback($$v) {
        _vm.activeCompanyIndex = $$v;
      },
      expression: "activeCompanyIndex"
    }
  }, [_vm._l(_vm.companies, function (item, index) {
    return [_c('v-list-item', {
      key: 'company' + index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('v-list-item-icon', [_c('v-icon', {
            attrs: {
              "color": item.company ? '' : 'primary'
            }
          }, [_vm._v(" " + _vm._s(_vm.serviceIconMap(item.service)) + " ")])], 1), _c('v-list-item-content', [item.company ? _c('v-list-item-title', [_vm._v(" " + _vm._s(item.company.companyName) + " ")]) : _c('v-list-item-title', {
            staticClass: "primary--text"
          }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.contact.assign")) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.serviceName(item)) + " ")])], 1), item.company ? _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1) : _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
        },
        proxy: true
      }], null, true)
    }), index < _vm.companies.length - 1 ? _c('v-divider', {
      key: index
    }) : _vm._e()];
  })], 2)], 1)], 1) : _vm._e(), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_vm.activeCompany && !_vm.activeCompany.company ? _c('div', {
    class: !_vm.isMobile ? 'd-flex align-center justify-center' : '',
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": "",
      "loading": _vm.isAssignLoading
    }
  }, [_vm.isMobile ? _c('v-card-title', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.activeCompanyIndex = null;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1) : _vm._e(), _c('v-img', {
    attrs: {
      "height": "70"
    }
  }, [_c('v-icon', {
    staticClass: "d-flex justify-center align-center",
    attrs: {
      "size": "70"
    }
  }, [_vm._v(" " + _vm._s(_vm.serviceIconMap(_vm.activeCompany.service)) + " ")])], 1), _c('v-card-title', {
    staticClass: "justify-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.contact.assignTitle", {
    type: _vm.serviceName(_vm.activeCompany)
  })) + " ")]), _c('v-card-text', {
    staticClass: "justify-center text-center"
  }, [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.contact.assignSubtitle", {
    type: _vm.serviceName(_vm.activeCompany)
  })) + " ")]), _c('v-card-actions', {
    staticClass: "justify-center d-flex flex-column flex-sm-row"
  }, [_c('v-btn', {
    staticClass: "ma-2 px-4",
    attrs: {
      "outlined": ""
    },
    on: {
      "click": function click($event) {
        return _vm.startAssignCompany(_vm.activeCompany.service);
      }
    }
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.contact.add", {
    type: _vm.serviceName(_vm.activeCompany)
  })) + " ")])]), _c('v-btn', {
    staticClass: "ma-2 px-4",
    attrs: {
      "elevation": "0",
      "disabled": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _c('span', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.contact.create", {
    type: _vm.serviceName(_vm.activeCompany)
  })) + " ")])], 1)], 1), _vm.activeCompany && _vm.activeCompany.service ? _c('v-card-actions', [_c('v-list', {
    attrs: {
      "width": "100%"
    }
  }, [_vm._l(_vm.suggestFleetCompaniesByType(_vm.activeCompany.service), function (item, index) {
    return [_c('v-list-item', {
      key: "suggestion-".concat(_vm.activeCompany.service, "-").concat(index),
      attrs: {
        "disabled": _vm.isAssignLoading
      },
      on: {
        "click": function click($event) {
          return _vm.selectCompany(item, _vm.activeCompany.service);
        }
      }
    }, [_c('refs-company', {
      attrs: {
        "item": item,
        "small": true
      },
      scopedSlots: _vm._u([{
        key: "icon",
        fn: function fn() {
          return [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
        },
        proxy: true
      }, {
        key: "action",
        fn: function fn() {
          return [_c('v-icon', {
            attrs: {
              "color": "primary"
            }
          }, [_vm._v("mdi-creation")])];
        },
        proxy: true
      }], null, true)
    })], 1)];
  })], 2)], 1) : _vm._e()], 1)], 1) : _vm.activeCompany && _vm.activeCompany.company ? _c('v-card', {
    staticClass: "ma-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.activeCompany.company.companyName) + " "), _c('v-spacer'), !_vm.isMobile ? _c('span', [_vm.canShareContent ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-link-variant",
      "loading": _vm.isLoadingSharedContent,
      "disabled": _vm.isLoadingEmailDialog
    },
    on: {
      "click": function click($event) {
        var _vm$activeCompany;

        return _vm.openSharedContent((_vm$activeCompany = _vm.activeCompany) === null || _vm$activeCompany === void 0 ? void 0 : _vm$activeCompany.company, _vm.resourceEnum.COMPANY);
      }
    }
  }) : _vm._e(), _vm.activeCompany.company.contact ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-phone",
      "href": "tel:".concat(_vm.activeCompany.company.contact.phone)
    }
  }) : _vm._e(), _vm.activeCompany.company.contact && _vm.activeCompany.company.contact.email && _vm.canShareContent && _vm.canCreateMessage ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-email-outline",
      "loading": _vm.isLoadingEmailDialog,
      "disabled": _vm.isLoadingSharedContent
    },
    on: {
      "click": function click($event) {
        var _vm$activeCompany2;

        return _vm.openMail((_vm$activeCompany2 = _vm.activeCompany) === null || _vm$activeCompany2 === void 0 ? void 0 : _vm$activeCompany2.company, _vm.resourceEnum.COMPANY);
      }
    }
  }) : _vm._e(), _vm.activeCompany.company ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-open-in-new"
    },
    on: {
      "click": function click($event) {
        return _vm.goToCompany(_vm.activeCompany.company);
      }
    }
  }) : _vm._e(), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.startAssignCompany(_vm.activeCompany.service);
      }
    }
  }), _vm.activeCompany.company ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-trash-can",
      "loading": _vm.isAssignLoading
    },
    on: {
      "click": function click($event) {
        return _vm.removeCompany(_vm.activeCompany.service);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isMobile ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.activeCompanyIndex = null;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : _vm._e()], 1), _c('v-card-subtitle', [_c('v-icon', [_vm._v(" " + _vm._s(_vm.serviceIconMap(_vm.activeCompany.service)) + " ")]), _vm._v(" " + _vm._s(_vm.serviceName(_vm.activeCompany)) + " ")], 1), _vm.isMobile ? _c('v-card-subtitle', [_vm.canShareContent ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-link-variant",
      "loading": _vm.isLoadingSharedContent,
      "disabled": _vm.isLoadingEmailDialog
    },
    on: {
      "click": function click($event) {
        var _vm$activeCompany3;

        return _vm.openSharedContent((_vm$activeCompany3 = _vm.activeCompany) === null || _vm$activeCompany3 === void 0 ? void 0 : _vm$activeCompany3.company, _vm.resourceEnum.COMPANY);
      }
    }
  }) : _vm._e(), _vm.activeCompany.company.contact ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-phone",
      "href": "tel:".concat(_vm.activeCompany.company.contact.phone)
    }
  }) : _vm._e(), _vm.activeCompany.company.contact && _vm.activeCompany.company.contact.email && _vm.canShareContent && _vm.canCreateMessage ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-email-outline",
      "loading": _vm.isLoadingEmailDialog,
      "disabled": _vm.isLoadingSharedContent
    },
    on: {
      "click": function click($event) {
        var _vm$activeCompany4;

        return _vm.openMail((_vm$activeCompany4 = _vm.activeCompany) === null || _vm$activeCompany4 === void 0 ? void 0 : _vm$activeCompany4.company, _vm.resourceEnum.COMPANY);
      }
    }
  }) : _vm._e(), _vm.activeCompany.company ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-open-in-new"
    },
    on: {
      "click": function click($event) {
        return _vm.goToCompany(_vm.activeCompany.company);
      }
    }
  }) : _vm._e(), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "elevation": "0"
    },
    on: {
      "click": function click($event) {
        return _vm.startAssignCompany(_vm.activeCompany.service);
      }
    }
  }), _vm.activeCompany.company ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-trash-can",
      "disabled": ""
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.debug ? _c('v-card-subtitle', [_vm._v(" (" + _vm._s(_vm.activeCompany.company.id) + ") ")]) : _vm._e(), _c('v-card-text', [_c('v-tabs', {
    model: {
      value: _vm.companyTab,
      callback: function callback($$v) {
        _vm.companyTab = $$v;
      },
      expression: "companyTab"
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "info"
    }
  }), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("common.nouns.overview")) + " ")]), _c('v-tab', [_vm._v(" " + _vm._s(_vm.$t("Info")) + " ")]), _c('v-tab-item', [_c('v-row', {
    staticClass: "py-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.phone'),
      "readonly": "",
      "value": _vm.activeCompanyPhone
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.email'),
      "readonly": "",
      "value": _vm.activeCompanyMail
    }
  })], 1), _c('v-divider'), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.address'),
      "readonly": "",
      "value": _vm.activeCompanyAddress
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  })], 1)], 1), _c('v-tab-item', [_c('v-row', {
    staticClass: "py-6"
  }, [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('language'),
      "value": _vm.$t("enums.LanguageCodeEnum.".concat(_vm.activeCompany.company.language)) + ' ' + _vm.getFlagEmojiByLanguage(_vm.activeCompany.company.language),
      "readonly": ""
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('objects.person.taxnumber'),
      "readonly": "",
      "value": _vm.activeCompany.company.taxnumber
    }
  })], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.contact.addCompany"),
      "isDialogActive": _vm.isAssignDialogOpen,
      "width": '800px',
      "rightDisabled": _vm.isAssignValid,
      "rightLoading": _vm.isAssignLoading,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAssignDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAssignDialogOpen = $event;
      },
      "rightClick": _vm.addCompany
    }
  }, [_c('company-selection-table', {
    key: 'company-selection-' + _vm.filter,
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: _vm.companyToAdd,
      callback: function callback($$v) {
        _vm.companyToAdd = $$v;
      },
      expression: "companyToAdd"
    }
  })], 1)], 1), _c('v-tab-item', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), !_vm.isMobile || _vm.isMobile && !_vm.activePerson ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-list', {
    staticClass: "py-0"
  }, [_c('v-list-item-group', {
    model: {
      value: _vm.activePersonIndex,
      callback: function callback($$v) {
        _vm.activePersonIndex = $$v;
      },
      expression: "activePersonIndex"
    }
  }, [_vm._l(_vm.persons, function (item, index) {
    return [_c('v-list-item', {
      key: 'person' + index,
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn(_ref) {
          var active = _ref.active;
          return [_c('v-list-item-icon', [_vm.isDriver(item) ? _c('v-icon', [_vm._v(" " + _vm._s(_vm.typeIconMap(_vm.PersonType.DRIVER)) + " ")]) : _c('v-icon', [_vm._v(" " + _vm._s(_vm.typeIconMap(_vm.PersonType.OTHER)) + " ")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.firstName) + " " + _vm._s(item.lastName) + " ")]), _c('v-list-item-subtitle', [_vm._v(" " + _vm._s(_vm.$t("enums.PersonType.".concat(_vm.isDriver(item) ? _vm.PersonType.DRIVER : _vm.PersonType.OTHER))) + " ")])], 1), !active ? _c('v-list-item-action', [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1) : _vm._e()];
        }
      }], null, true)
    }), index < _vm.companies.length - 1 ? _c('v-divider', {
      key: index
    }) : _vm._e()];
  })], 2)], 1), _c('v-list', [_c('v-list-item', [_c('v-btn', {
    attrs: {
      "elevation": "0",
      "block": ""
    },
    on: {
      "click": _vm.startAddContact
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" " + _vm._s(_vm.$t("add")) + " ")], 1)], 1)], 1)], 1) : _vm._e(), _c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_vm.activePerson ? _c('v-card', {
    staticClass: "ma-1",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.activePerson.firstName) + " " + _vm._s(_vm.activePerson.lastName) + " "), _c('v-spacer'), !_vm.isMobile ? _c('span', [_vm.canShareContent ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-link-variant",
      "loading": _vm.isLoadingSharedContent,
      "disabled": _vm.isLoadingEmailDialog
    },
    on: {
      "click": function click($event) {
        return _vm.openSharedContent(_vm.activePerson, _vm.resourceEnum.PERSON);
      }
    }
  }) : _vm._e(), _vm.whatsappLink && _vm.isDriver(_vm.activePerson) ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-whatsapp",
      "href": "#"
    },
    on: {
      "click": _vm.openWhatsapp
    }
  }) : _vm._e(), _vm.activePerson.primaryPhone ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-phone",
      "href": "tel:".concat(_vm.activePerson.primaryPhone)
    }
  }) : _vm._e(), _vm.activePerson.primaryEmail && _vm.canShareContent && _vm.canCreateMessage ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-email-outline",
      "loading": _vm.isLoadingEmailDialog,
      "disabled": _vm.isLoadingSharedContent
    },
    on: {
      "click": function click($event) {
        return _vm.openMail(_vm.activePerson, _vm.resourceEnum.PERSON);
      }
    }
  }) : _vm._e(), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-open-in-new"
    },
    on: {
      "click": function click($event) {
        return _vm.goToPerson(_vm.activePerson);
      }
    }
  }), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "disabled": ""
    }
  }), _vm.activePerson.id ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-trash-can",
      "loading": _vm.isLoadingDeletePerson
    },
    on: {
      "click": function click($event) {
        return _vm.removePerson(_vm.activePerson);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.isMobile ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click($event) {
        _vm.activePersonIndex = null;
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1) : _vm._e()], 1), _vm.activePerson.id === _vm.report.personId ? _c('v-card-subtitle', [_c('v-icon', [_vm._v(" " + _vm._s(_vm.typeIconMap(_vm.PersonType.DRIVER)) + " ")]), _vm._v(" " + _vm._s(_vm.$t("enums.PersonType.".concat(_vm.PersonType.DRIVER))) + " ")], 1) : _c('v-card-subtitle', [_c('v-icon', [_vm._v(" " + _vm._s(_vm.typeIconMap(_vm.PersonType.OTHER)) + " ")]), _vm._v(" " + _vm._s(_vm.$t("enums.PersonType.".concat(_vm.PersonType.OTHER))) + " ")], 1), _vm.isMobile ? _c('v-card-subtitle', [_vm.canShareContent ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-link-variant",
      "loading": _vm.isLoadingSharedContent,
      "disabled": _vm.isLoadingEmailDialog
    },
    on: {
      "click": function click($event) {
        return _vm.openSharedContent(_vm.activePerson, _vm.resourceEnum.PERSON);
      }
    }
  }) : _vm._e(), _vm.whatsappLink && _vm.isDriver(_vm.activePerson) ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-whatsapp",
      "href": "#"
    },
    on: {
      "click": _vm.openWhatsapp
    }
  }) : _vm._e(), _vm.activePerson.primaryPhone ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-phone",
      "href": "tel:".concat(_vm.activePerson.primaryPhone)
    }
  }) : _vm._e(), _vm.activePerson.primaryEmail && _vm.canShareContent && _vm.canCreateMessage ? _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-email-outline",
      "loading": _vm.isLoadingEmailDialog,
      "disabled": _vm.isLoadingSharedContent
    },
    on: {
      "click": function click($event) {
        return _vm.openMail(_vm.activePerson, _vm.resourceEnum.PERSON);
      }
    }
  }) : _vm._e(), _c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-open-in-new"
    },
    on: {
      "click": function click($event) {
        return _vm.goToPerson(_vm.activePerson);
      }
    }
  })], 1) : _vm._e(), _vm.debug ? _c('v-card-subtitle', [_vm._v(" (" + _vm._s(_vm.activePerson.id) + ") ")]) : _vm._e(), _c('v-card-text', [_vm.isDriver(_vm.activePerson) && _vm.report.firstName && _vm.report.lastName && (_vm.activePerson.firstName !== _vm.report.firstName || _vm.activePerson.lastName !== _vm.report.lastName) ? _c('v-alert', {
    staticClass: "dense",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "grow",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.PartnerReportDetail.contact.nameDiffers', {
        name: _vm.report.firstName + ' ' + _vm.report.lastName
      }))
    }
  }), _c('v-col', {
    staticClass: "shrink"
  }, [_c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil"
    },
    on: {
      "click": function click($event) {
        _vm.isAlignActivePersonNameDialogActive = true;
      }
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAlignActivePersonNameDialogActive,
      "title": _vm.$t('components.PartnerReportDetail.contact.alignMasterData'),
      "subtitle": _vm.$t('components.PartnerReportDetail.contact.alignNameSubtitle'),
      "loading": _vm.isAlignActivePersonNameLoading,
      "rightLoading": _vm.isAlignActivePersonNameLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonNameDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonNameDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAlignActivePersonNameDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAlignActivePersonNameDialogActive = false;
      },
      "rightClick": function rightClick($event) {
        return _vm.setActivePersonName(_vm.report.firstName, _vm.report.lastName);
      }
    }
  })], 1)], 1) : _vm._e(), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.phone'),
      "value": _vm.activePerson.primaryPhone,
      "readonly": ""
    }
  }), _vm.isDriver(_vm.activePerson) && _vm.report.customerContact && _vm.activePerson.primaryPhone !== _vm.report.customerContact.phone ? _c('v-alert', {
    staticClass: "dense",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "grow",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.PartnerReportDetail.contact.primaryPhoneDiffers', {
        phone: _vm.report.customerContact.phone
      }))
    }
  }), _c('v-col', {
    staticClass: "shrink"
  }, [_c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil"
    },
    on: {
      "click": function click($event) {
        _vm.isAlignActivePersonPhoneDialogActive = true;
      }
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAlignActivePersonPhoneDialogActive,
      "title": _vm.$t('components.PartnerReportDetail.contact.alignMasterData'),
      "subtitle": _vm.$t('components.PartnerReportDetail.contact.alignPhoneSubtitle'),
      "loading": _vm.isAlignActivePersonPhoneLoading,
      "rightLoading": _vm.isAlignActivePersonPhoneLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonPhoneDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonPhoneDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAlignActivePersonPhoneDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAlignActivePersonPhoneDialogActive = false;
      },
      "rightClick": function rightClick($event) {
        return _vm.setActivePersonPrimaryPhone(_vm.report.customerContact.phone);
      }
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.email'),
      "value": _vm.activePerson.primaryEmail,
      "readonly": ""
    }
  }), _vm.isDriver(_vm.activePerson) && _vm.report.customerContact && _vm.activePerson.primaryEmail !== _vm.report.customerContact.email ? _c('v-alert', {
    staticClass: "dense",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "grow",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.PartnerReportDetail.contact.primaryEmailDiffers', {
        email: _vm.report.customerContact.email
      }))
    }
  }), _c('v-col', {
    staticClass: "shrink"
  }, [_c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil"
    },
    on: {
      "click": function click($event) {
        _vm.isAlignActivePersonEmailDialogActive = true;
      }
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAlignActivePersonEmailDialogActive,
      "title": _vm.$t('components.PartnerReportDetail.contact.alignMasterData'),
      "subtitle": _vm.$t('components.PartnerReportDetail.contact.alignEmailSubtitle'),
      "loading": _vm.isAlignActivePersonEmailLoading,
      "rightLoading": _vm.isAlignActivePersonEmailLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonEmailDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonEmailDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAlignActivePersonEmailDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAlignActivePersonEmailDialogActive = false;
      },
      "rightClick": function rightClick($event) {
        return _vm.setActivePersonPrimaryEmail(_vm.report.customerContact.email);
      }
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _c('v-divider'), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.address'),
      "value": _vm.activePerson.billingAddress,
      "readonly": ""
    }
  }), _vm.isDriver(_vm.activePerson) && _vm.report.customerAddress && _vm.activePerson.billingAddress && _vm.activePerson.billingAddress.toString() !== _vm.report.customerAddress.toString() ? _c('v-alert', {
    staticClass: "dense",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "grow",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.PartnerReportDetail.contact.primaryAddressDiffers', {
        address: (_vm$report$customerAd = _vm.report.customerAddress) === null || _vm$report$customerAd === void 0 ? void 0 : _vm$report$customerAd.toString()
      }))
    }
  }), _c('v-col', {
    staticClass: "shrink"
  }, [_c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil"
    },
    on: {
      "click": function click($event) {
        _vm.isAlignActivePersonAddressDialogActive = true;
      }
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAlignActivePersonAddressDialogActive,
      "title": _vm.$t('components.PartnerReportDetail.contact.alignMasterData'),
      "subtitle": _vm.$t('components.PartnerReportDetail.contact.alignAddressSubtitle'),
      "loading": _vm.isAlignActivePersonAddressLoading,
      "rightLoading": _vm.isAlignActivePersonAddressLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonAddressDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonAddressDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAlignActivePersonAddressDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAlignActivePersonAddressDialogActive = false;
      },
      "rightClick": function rightClick($event) {
        return _vm.setActivePersonAddress(_vm.report.customerAddress);
      }
    }
  })], 1)], 1) : _vm._e()], 1), _c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('common.nouns.company')
    },
    model: {
      value: _vm.report.companyName,
      callback: function callback($$v) {
        _vm.$set(_vm.report, "companyName", $$v);
      },
      expression: "report.companyName"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('m-text-field', {
    attrs: {
      "label": _vm.$t('language'),
      "value": _vm.$t("enums.LanguageCodeEnum.".concat(_vm.activePerson.language)) + ' ' + _vm.getFlagEmojiByLanguage(_vm.activePerson.language),
      "readonly": ""
    }
  }), _vm.isDriver(_vm.activePerson) && _vm.report.language && _vm.activePerson.language !== _vm.report.language ? _c('v-alert', {
    staticClass: "dense",
    attrs: {
      "color": _vm.$vuetify.theme.dark ? 'grey darken-3' : 'grey lighten-4'
    }
  }, [_c('v-row', {
    attrs: {
      "align": "center",
      "no-gutters": ""
    }
  }, [_c('v-col', {
    staticClass: "grow",
    staticStyle: {
      "word-break": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('components.PartnerReportDetail.contact.languageDiffers', {
        language: _vm.$t("enums.LanguageCodeEnum.".concat(_vm.report.language))
      }))
    }
  }), _c('v-col', {
    staticClass: "shrink"
  }, [_c('m-icon-button', {
    staticClass: "mx-1",
    attrs: {
      "icon": "mdi-pencil"
    },
    on: {
      "click": function click($event) {
        _vm.isAlignActivePersonLanguageDialogActive = true;
      }
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isAlignActivePersonLanguageDialogActive,
      "title": _vm.$t('components.PartnerReportDetail.contact.alignMasterData'),
      "subtitle": _vm.$t('components.PartnerReportDetail.contact.alignLanguageSubtitle'),
      "loading": _vm.isAlignActivePersonLanguageLoading,
      "rightLoading": _vm.isAlignActivePersonLanguageLoading
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonLanguageDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAlignActivePersonLanguageDialogActive = $event;
      },
      "close": function close($event) {
        _vm.isAlignActivePersonLanguageDialogActive = false;
      },
      "leftClick": function leftClick($event) {
        _vm.isAlignActivePersonLanguageDialogActive = false;
      },
      "rightClick": function rightClick($event) {
        return _vm.setActivePersonLanguage(_vm.report.language);
      }
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.contact.addContact"),
      "isDialogActive": _vm.isAddContactDialogOpen,
      "rightLoading": _vm.isAddContactLoading,
      "hideLeft": true,
      "width": '800px'
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isAddContactDialogOpen = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isAddContactDialogOpen = $event;
      },
      "rightClick": _vm.addContact
    }
  }, [_c('person-selection-table', {
    attrs: {
      "cache": false
    },
    model: {
      value: _vm.contactToAdd,
      callback: function callback($$v) {
        _vm.contactToAdd = $$v;
      },
      expression: "contactToAdd"
    }
  })], 1)], 1)], 1)], 1), _c('template-dialog', {
    key: _vm.templateEditorKey,
    ref: "templateDialog",
    attrs: {
      "hideButton": true,
      "partnerId": _vm.partner.id,
      "context": _vm.context,
      "fullscreen": false,
      "to": [],
      "from": [_vm.partner],
      "refs": _vm.refs,
      "isTicketEnabled": true
    }
  }), _vm.sharedContentSideCardItem ? _c('shared-content-side-card', {
    attrs: {
      "value": _vm.sharedContentSideCardItem,
      "referenceCategories": [_vm.ResourceEnum.DOCUMENT, _vm.ResourceEnum.RENTAL, _vm.ResourceEnum.APPRAISAL, _vm.ResourceEnum.REPAIR_ESTIMATE, _vm.ResourceEnum.CLEARANCE, _vm.ResourceEnum.CLEARANCE_APPROVAL, _vm.ResourceEnum.ATTACHMENT_REQUEST],
      "suggested": _vm.report.suggestedRefs,
      "hideSuggested": false,
      "filters": _vm.filters
    },
    on: {
      "close": function close($event) {
        _vm.sharedContentSideCardItem = null;
      }
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }